import 'datatables.net-responsive-bs4'
import 'datatables.net-buttons'
import 'datatables.net-buttons-bs4'
import './buttons/custom-colvis'
import './buttons/filter'
import './buttons/search'
import './buttons/sort'
import './lang'

$.extend( $.fn.dataTable.ext.order, {
    noSort: function(settings) {
        return settings.aoData
    }
});
